import React from 'react';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { ResponsiveAdPlacementMmaBase } from './responsive-mma-ad-placement-base';

import {
  getResponsiveMmaInMsanMSEdgeSingleCarousel178x100Styles,
  getResponsiveMmaInMsanMSNInArticle150x100Styles,
  getResponsiveMmaInMsanMSNSmallHeadline133x100Styles,
  getResponsiveMmaInMsanSquareImage1x1Styles,
  getResponsiveMmaInMsanWideImage191x100Styles,
} from '../../styles';

export const ResponsiveAdPlacementMmaInMsanWideImage191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    isMultiLineDescription
    showBusinessName
    showBusinessNameAdLabel
  />),
  getResponsiveMmaInMsanWideImage191x100Styles,
  { componentName: 'AdPlacementMmaInMsanWideImage191x100' }
);

export const ResponsiveAdPlacementMmaInMsanMSEdgeSingleCarousel178x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getResponsiveMmaInMsanMSEdgeSingleCarousel178x100Styles,
  { componentName: 'AdPlacementMmaInMsanMSEdgeSingleCarousel178x100' }
);

export const ResponsiveAdPlacementMmaInMsanMSNInArticle150x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    isMultiLineDescription
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getResponsiveMmaInMsanMSNInArticle150x100Styles,
  { componentName: 'AdPlacementMmaInMsanMSNInArticle150x100' }
);

export const ResponsiveAdPlacementMmaInMsanMSNSmallHeadline133x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getResponsiveMmaInMsanMSNSmallHeadline133x100Styles,
  { componentName: 'AdPlacementMmaInMsanMSNSmallHeadline133x100' }
);

export const ResponsiveAdPlacementMmaInMsanSquareImage1x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getResponsiveMmaInMsanSquareImage1x1Styles,
  { componentName: 'AdPlacementMmaInMsanSquareImage1x1' }
);
